type FaceMatch = {
    rank?: number;
    voterid?: string;
    voter?: any;
    service_requests?: any[];
    [key: string]: any;
};

const enrichSubjectPhone = (sr: any, match?: FaceMatch) => {
    const voterPhone = match?.voter?.phone || "";
    const subjectInner = sr?.subject?.subject;

    if (!sr?.subject || !subjectInner) {
        return sr;
    }

    return {
        ...sr,
        subject: {
            ...sr.subject,
            subject: {
                ...subjectInner,
                whatsapp:
                    subjectInner?.whatsapp ||
                    subjectInner?.phone ||
                    voterPhone ||
                    "",
            },
        },
    };
};

export const extractFaceMatchServiceRequests = (matches: any[]): any[] => {
    if (!Array.isArray(matches)) {
        return [];
    }

    return matches.flatMap((match: FaceMatch) => {
        if (Array.isArray(match?.service_requests)) {
            return match.service_requests.map((sr) => enrichSubjectPhone(sr, match));
        }

        if (match?.id && (match?.trackingid || match?.type)) {
            return [enrichSubjectPhone(match)];
        }

        return [];
    });
};

export const getFaceRequestStatusLabel = (request: any): string => {
    const nested = request?.status?.status;

    if (typeof nested === "string") {
        return nested;
    }

    if (nested?.status) {
        return nested.status;
    }

    if (typeof request?.status === "string") {
        return request.status;
    }

    return "N/A";
};

export const getFaceRequestTypeName = (request: any): string =>
    request?.type?.type?.name || request?.type?.name || "Service Request";

export const getFaceRequestTrackingId = (request: any): string =>
    request?.trackingid || request?.tracking_id || "N/A";

export const getFaceRequestSubjectName = (request: any): string =>
    request?.subject?.subject?.profile?.name_eng || "N/A";
